import React from "react"

import styles from "./LegalPageContent.module.scss"

const LegalPageContent = ({ children }) => {
  return <div className={styles.content}>{children}</div>
}

export default LegalPageContent
